var _rect, _polygon, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.28,125.93s-8.36-5.1-17.6,14.78S690.07,172,690.07,172s-2.49,4.18-5.39,1.61-7-10-11.76-8.48c-4.9,1.59-6.33,7.18-5.09,15.27s3.29,25.91,3.48,27.52-.65,4-2.91,2.52-15.46-15.11-21.58-8.46,1,28.62,1.78,31,.29,3.47-.85,4.12-5.14-4.37-9-8.11-9.11-7.38-12.31-3.25-3.68,20.83,13.15,47.31l8.6,11.76,14.57-1.34c31-4.76,43.26-16.1,44.26-21.23s-5.16-6.65-10.54-7.13-11.8-.21-12.06-1.49.24-2.31,2.55-3.34,23.54-10.11,24.53-19.1-18-9.91-20.57-10.67-1.33-2.94,0-3.85,16.11-11.1,23-15.49S724,192.05,722,187.31c-2-4.57-10.27-2.77-14.12-3.27s-2.33-5.12-2.33-5.12,6.37-10,15.25-30.07-.71-23-.71-23",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712,143.72s-.05.15-.17.43-.3.72-.52,1.25l-2.06,4.75c-1.8,4.13-4.44,10.09-7.73,17.44-6.58,14.7-15.84,34.92-26.14,57.22S655.74,267.33,649.08,282l-7.87,17.37-2.14,4.72c-.25.52-.44.93-.57,1.22a4.43,4.43,0,0,1-.21.41,3.57,3.57,0,0,1,.16-.43c.13-.3.3-.71.52-1.24.48-1.11,1.18-2.71,2.06-4.76,1.8-4.13,4.44-10.08,7.73-17.43,6.58-14.7,15.84-34.92,26.14-57.23s19.61-42.51,26.27-57.17c3.32-7.31,6-13.24,7.87-17.36l2.15-4.72c.24-.53.43-.93.57-1.23S712,143.72,712,143.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.27,175.77a4.14,4.14,0,0,1,.41,1c.24.63.55,1.56.93,2.71.74,2.31,1.69,5.51,2.67,9.07l2.47,9.12c.3,1.09.55,2,.76,2.76a3.83,3.83,0,0,1,.23,1,4.14,4.14,0,0,1-.41-1c-.24-.63-.55-1.56-.92-2.72-.72-2.31-1.63-5.53-2.61-9.09l-2.53-9.1-.77-2.75A4.51,4.51,0,0,1,678.27,175.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.09,201.64c0-.13,6.48-2.38,14.57-5s14.69-4.69,14.73-4.56-6.48,2.38-14.57,5S687.13,201.77,687.09,201.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.72,235.18a5.3,5.3,0,0,1,1.08-.09l2.92-.1c2.46-.09,5.87-.22,9.62-.51s7.14-.63,9.6-.91l2.9-.33a4.21,4.21,0,0,1,1.08-.06,5,5,0,0,1-1,.25c-.68.13-1.67.3-2.89.48-2.44.37-5.84.79-9.6,1.07s-7.18.36-9.66.35c-1.23,0-2.23,0-2.92-.05A4.15,4.15,0,0,1,669.72,235.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6,213.54a4.06,4.06,0,0,1,.6.79c.36.52.88,1.29,1.5,2.25,1.25,1.91,2.94,4.57,4.78,7.52s3.49,5.64,4.66,7.6c.59,1,1.05,1.78,1.36,2.34a3.73,3.73,0,0,1,.45.89,3.44,3.44,0,0,1-.61-.79c-.36-.53-.87-1.29-1.5-2.25-1.24-1.91-2.93-4.57-4.78-7.53s-3.49-5.64-4.66-7.6c-.58-1-1-1.78-1.36-2.33A4.13,4.13,0,0,1,656.6,213.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.5,241.2a5.93,5.93,0,0,1,.77,1l1.93,2.88c1.6,2.44,3.8,5.83,6.2,9.59s4.55,7.19,6.08,9.68l1.8,3a7.18,7.18,0,0,1,.6,1.12,6.06,6.06,0,0,1-.77-1l-1.92-2.88c-1.61-2.45-3.81-5.84-6.21-9.6s-4.54-7.19-6.08-9.68c-.72-1.18-1.32-2.18-1.79-3A6,6,0,0,1,637.5,241.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.65,267.69a6.42,6.42,0,0,1,1.35-.16l3.7-.26c3.12-.22,7.44-.54,12.19-1s9-1,12.15-1.43l3.67-.49a7.58,7.58,0,0,1,1.36-.12,6.76,6.76,0,0,1-1.33.31c-.86.17-2.11.39-3.65.64-3.1.51-7.39,1.11-12.15,1.59s-9.09.75-12.22.88c-1.57.06-2.83.1-3.71.1A8,8,0,0,1,654.65,267.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.79,224.43c23.33-15.57,29-45,28.53-71.59-.09-4.44.48-9.1-1.6-13s-7-6.66-11.07-4.85c-3.35,1.5-4.87,5.31-6.78,8.45a26.23,26.23,0,0,1-10.69,9.77c-2.88,1.42-6.43,2.26-9.23.68-3.84-2.16-4.22-7.45-4.12-11.86l.54-24.64c.09-4.41.18-8.91-1.15-13.12s-4.33-8.13-8.56-9.37-9.52,1.1-10.49,5.4c-.4,1.79-.06,3.66-.21,5.49s-1,3.84-2.82,4.32-3.55-.79-4.87-2.09c-4.54-4.53-7.58-10.3-10.41-16s-5.59-11.63-9.69-16.54-9.84-8.85-16.23-9.31-13.26,3.35-15,9.52,1.86,12.55,5.78,17.64A99.14,99.14,0,0,0,57.19,113.1c1.4,1,2.9,2.09,3.42,3.73.92,3-1.94,5.83-4.9,6.76-3.35,1-7,.65-10.44,1s-7.29,1.81-8.66,5c-1.89,4.48,1.85,9.26,5.56,12.41a85.7,85.7,0,0,0,25,14.77c3.27,1.24,6.71,2.33,9.32,4.65s4.16,6.3,2.51,9.38-5.78,4-9.21,3.34-6.48-2.57-9.74-3.84c-6.11-2.38-14-2.08-18.05,3.1-2.64,3.4-2.94,8.19-1.7,12.31s3.84,7.69,6.6,11c9.66,11.54,22.12,20.9,36.28,26s27.33,6.6,41.56,1.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,224.94c-3.75-13.45-14-45.1-20.15-60l-4.57-11c-1.51-3.61-3-7.18-4.69-10.59a197.94,197.94,0,0,0-10.8-19c-3.74-5.9-7.5-11.36-11-16.45s-7-9.74-10.28-13.87a157.36,157.36,0,0,0-17-18.31c-2.17-2-3.9-3.5-5.09-4.5L38,70c-.31-.25-.48-.37-.48-.37s.14.15.43.42l1.32,1.18c1.15,1,2.86,2.56,5,4.59a167,167,0,0,1,16.8,18.41c3.26,4.14,6.64,8.82,10.19,13.9s7.27,10.56,11,16.45a198.47,198.47,0,0,1,10.73,19c1.67,3.4,3.16,7,4.67,10.57s3,7.29,4.57,11c6.11,14.88,16.39,46.5,20.17,59.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.38,143.28a10,10,0,0,0,.44-1.88c.24-1.22.54-3,.88-5.18.69-4.38,1.44-10.46,2.25-17.17s1.66-12.76,2.44-17.12c.38-2.18.71-3.94,1-5.15a11.48,11.48,0,0,0,.31-1.9,10.1,10.1,0,0,0-.56,1.84c-.33,1.2-.73,3-1.17,5.13C98,106.19,97.1,112.26,96.29,119s-1.51,12.67-2.05,17.19c-.27,2.1-.5,3.85-.68,5.2A11.22,11.22,0,0,0,93.38,143.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.12,131.83a2.13,2.13,0,0,0,.59.1l1.7.17c1.48.15,3.61.35,6.23.68,5.25.62,12.48,1.75,20.4,3.34s15,3.38,20.1,4.81c2.55.7,4.6,1.32,6,1.74l1.64.48a2,2,0,0,0,.58.13,2,2,0,0,0-.54-.25c-.44-.17-1-.37-1.6-.6-1.39-.5-3.43-1.2-6-2-5.07-1.55-12.17-3.4-20.1-5S50,132.82,44.69,132.31c-2.63-.27-4.78-.4-6.26-.46l-1.71,0A2.41,2.41,0,0,0,36.12,131.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.42,206.63a4,4,0,0,0,.39-.69l1-2c.86-1.78,2-4.38,3.48-7.61,2.86-6.45,6.53-15.49,10.46-25.51S140.27,151.7,143,145.2l3.28-7.68c.36-.86.66-1.55.89-2.09a4.24,4.24,0,0,0,.27-.75,2.84,2.84,0,0,0-.39.69l-1,2c-.86,1.78-2.05,4.38-3.47,7.6-2.86,6.46-6.54,15.5-10.46,25.52s-7.53,19.08-10.28,25.58l-3.28,7.68-.88,2.09A3.4,3.4,0,0,0,117.42,206.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,181.22a4,4,0,0,0,.75.3l2.21.75L52.59,185c6.87,2.3,16.32,5.59,26.75,9.25s19.92,6.88,26.83,9.07c3.45,1.09,6.26,1.95,8.2,2.51l2.25.63a3.89,3.89,0,0,0,.8.18,4.27,4.27,0,0,0-.76-.31l-2.21-.75-8.14-2.71c-6.87-2.3-16.32-5.59-26.75-9.25s-19.91-6.89-26.82-9.07c-3.46-1.09-6.26-1.95-8.21-2.51l-2.24-.64A4.19,4.19,0,0,0,41.49,181.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.76,70.37H634.83L610.17,87.9v14.64a27.28,27.28,0,0,1-27.48,27.07H503.58a27.28,27.28,0,0,1-27.48-27.07h0A32.41,32.41,0,0,1,508.76,70.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.9,89.94c0,.14-21,.26-47,.26s-47-.12-47-.26,21-.26,47-.26S588.9,89.79,588.9,89.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.9,99.68c0,.14-21,.26-47,.26s-47-.12-47-.26,21-.26,47-.26S588.9,99.53,588.9,99.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.49,370.42H168.31L192.61,388v34.5a7.2,7.2,0,0,0,7.21,7.2H317.49a7.2,7.2,0,0,0,7.21-7.2V377.62A7.21,7.21,0,0,0,317.49,370.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,394.8c0,.15-22.5.26-50.25.26s-50.25-.11-50.25-.26,22.49-.26,50.25-.26S311.27,394.66,311.27,394.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,408.05c0,.14-22.5.26-50.25.26s-50.25-.12-50.25-.26,22.49-.26,50.25-.26S311.27,407.91,311.27,408.05Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-118"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.7,
    y: 200.4,
    width: 252.17,
    height: 219.68,
    rx: 38.79,
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 408.7,
    y: 200.4,
    width: 252.17,
    height: 219.68,
    rx: 38.79
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "660.8 276.98 698.57 276.98 659.95 315.61 660.8 276.98",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "660.8 276.98 698.57 276.98 659.95 315.61 660.8 276.98"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402.66,300.73l-15.83-18c-4.28-4.28-5.75-6.34-4.89-7.09,1.14-1,.65-.67,9.54,6,0,0-12.6-9.63-8.23-9.69.77,0,2.91,1.24,5.2,2.74-3.12-2.65-4-4.44-3.39-5.29,1-1.48,8.72,3.87,12.27,6.44-2.9-2.16-8.43-6.35-9.4-7.67-1.34-1.8,1.37-1.65,3.57-.9,2.47.84,16.12,7.81,20.16,9.61a2.61,2.61,0,0,0,3.76-1.27c1.49-6.26,6-10.33,7.72-10.86s3.05,1.67,1.82,3.27A23.86,23.86,0,0,0,422.3,274a15.47,15.47,0,0,0-.81,5.13c0,2,.14,3.73.27,5.18l14.47,19.85-24.2,14Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,284.44c-.16.22-3-1.71-6.28-4.32s-5.84-4.91-5.65-5.12,3,1.73,6.28,4.32S397.14,284.21,397,284.44Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.06,281.28c-.16.23-3.27-1.67-6.95-4.23s-6.54-4.83-6.38-5.05,3.27,1.66,6.95,4.22S400.22,281.05,400.06,281.28Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,277.92c-.16.23-3.14-1.51-6.65-3.89s-6.23-4.49-6.08-4.73,3.13,1.51,6.65,3.89S402.45,277.69,402.3,277.92Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.11,287l57.68,73.14-13.21,30.75s-15.82-3.5-20.62-10.16-44.3-80-44.3-80Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.53,184.68c4.15,3.6,4.14,9.94,3.66,15.41s-.85,11.7,2.94,15.68c3.13,3.28,8.8,4.71,9.52,9.18a5.15,5.15,0,0,1-8.51,4.67c1.22,3.53.38,7.94-2.68,10.08s-8.19.82-9.14-2.79a4.53,4.53,0,1,1-8.89,1.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.1,221.6A5.46,5.46,0,1,1,500,217.39c.95-2.08,3.2-3.58,3.42-5.86.26-2.75-2.55-4.72-5-5.92s-5.41-2.76-5.68-5.52,2.12-4.73,4.11-6.51,4-4.54,2.73-6.91c-.63-1.22-1.94-1.91-2.79-3-1.87-2.38-.89-6.17,1.5-8s5.69-2.12,8.67-1.59,5.78,1.77,8.68,2.64a36.21,36.21,0,0,0,28.84-3.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.81,286.09a20.08,20.08,0,0,0,23.59-15.4l14.19-65.06a28.87,28.87,0,0,0-22.27-34.9l-1.48-.22a29.06,29.06,0,0,0-32.55,22.25c-3.16,13.73-6.47,28.94-7.47,36.41-2.07,15.47,13,20.13,13,20.13l-2.71,13a20.08,20.08,0,0,0,15.68,23.76Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.07,203a2.24,2.24,0,0,0,1.8,2.54,2.13,2.13,0,0,0,2.56-1.65,2.22,2.22,0,0,0-1.79-2.54A2.14,2.14,0,0,0,512.07,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.5,200.8c.23.33,2.08-.67,4.46-.31s3.93,1.79,4.23,1.54c.15-.11-.06-.67-.73-1.33a6.12,6.12,0,0,0-3.34-1.59,5.89,5.89,0,0,0-3.6.6C511.71,200.17,511.39,200.65,511.5,200.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.26,206.8a2.23,2.23,0,0,0,1.8,2.54,2.13,2.13,0,0,0,2.56-1.66,2.22,2.22,0,0,0-1.8-2.53A2.12,2.12,0,0,0,535.26,206.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.76,204.66c.23.32,2.08-.67,4.45-.31s3.94,1.79,4.24,1.54c.14-.11-.06-.67-.74-1.33a6.12,6.12,0,0,0-3.34-1.59,5.89,5.89,0,0,0-3.6.6C535,204,534.64,204.51,534.76,204.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.57,221c0-.14-1.41-.61-3.75-1.26-.6-.15-1.15-.36-1.19-.79a3.14,3.14,0,0,1,.66-1.73q1.19-2.07,2.47-4.35c3.45-6.21,6-11.34,5.79-11.48s-3.25,4.78-6.7,11l-2.4,4.38a3.6,3.6,0,0,0-.66,2.34,1.54,1.54,0,0,0,.87,1,4.26,4.26,0,0,0,1,.29A15.94,15.94,0,0,0,523.57,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.5,195.27c.14.68,2.56.72,5.29,1.46s4.87,1.83,5.33,1.31c.2-.25-.1-.92-.91-1.67a9.52,9.52,0,0,0-8.09-2.11C536,194.52,535.45,195,535.5,195.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.38,194.06c.34.6,2,.28,4,.54s3.58.9,4,.39c.21-.25,0-.83-.62-1.45a5.87,5.87,0,0,0-6.5-.74C513.54,193.25,513.23,193.77,513.38,194.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.31,186.24l.07.08a12.26,12.26,0,0,1,3.36,8.52v.31c0,4.5-.81,9-.8,13.45s.87,9.19,3.68,12.69c1.15,1.45,3.39,2.65,4.7,1.35a3.8,3.8,0,0,0,.85-1.94c2.38-10.51,6.66-19.51,8.27-30.63a9.47,9.47,0,0,0-2.77-8.2c-2.08-2-4.67-4.16-7.44-3.31s-6.82,5.2-9.13,7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.36,211.85c.28-.08,11.07-1.59,9.18,8.92s-12,6.45-12,6.14S559.36,211.85,559.36,211.85Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.46,223.51s.16.16.44.35a1.87,1.87,0,0,0,1.37.28c1.18-.21,2.43-1.8,2.82-3.69a6.16,6.16,0,0,0,0-2.71,2.16,2.16,0,0,0-1.13-1.65.94.94,0,0,0-1.17.31c-.19.26-.16.49-.22.49s-.19-.21,0-.63a1.16,1.16,0,0,1,.53-.58,1.41,1.41,0,0,1,1.06-.09,2.63,2.63,0,0,1,1.62,2,6.31,6.31,0,0,1,.11,3c-.45,2.11-1.89,3.89-3.48,4.06a2,2,0,0,1-1.63-.58C560.43,223.76,560.42,223.52,560.46,223.51Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.35,180.25c3.22-3.85-3-10.95-8-13.36s-12.2-.87-17.64.09c-3.43.61-6.91,1.65-10.33,1a23.28,23.28,0,0,1-6.44-2.69A17.43,17.43,0,0,0,512.4,163a6.44,6.44,0,0,0-6.07,2.71c-1.19,2-.36,5.13,1.88,5.78a5.24,5.24,0,1,0-2.79,9.4c-1.33-1.36-3.91.19-4,2.09s1.41,3.51,3,4.52c4.11,2.58,9.33,2.71,14.11,1.85s9.36-2.64,14.12-3.62,12.75-2.84,17.05-.57c3.16,1.66,4.9,6,6.91,5.41a6.53,6.53,0,0,0,4-4.26,19,19,0,0,0,.67-6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.92,229a1.62,1.62,0,0,0,.55-.24,3.13,3.13,0,0,0,1.14-1.3,4.59,4.59,0,0,0,.34-2.72,5.46,5.46,0,0,0-1.88-3.08,13.7,13.7,0,0,0-3.79-2.21,24.61,24.61,0,0,1-4.43-2.14,8.84,8.84,0,0,1-3.21-4.17,14.62,14.62,0,0,1-.93-5.68c.1-4,1.21-7.75,1.48-11.28s-.18-6.84-1.68-9.13a8.47,8.47,0,0,0-5-3.75,5.84,5.84,0,0,0-1.71-.17,2.21,2.21,0,0,0-.59.09,8.72,8.72,0,0,1,2.25.28,8.44,8.44,0,0,1,4.72,3.75c1.39,2.22,1.87,5.44,1.52,8.89s-1.42,7.2-1.54,11.31a15,15,0,0,0,1,5.88,9.32,9.32,0,0,0,3.43,4.39,25.25,25.25,0,0,0,4.53,2.14,13.7,13.7,0,0,1,3.71,2.08,5.25,5.25,0,0,1,1.84,2.86,4.34,4.34,0,0,1-.24,2.57A3.44,3.44,0,0,1,581.92,229Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.87,171.24a1.81,1.81,0,0,0-.46-.25,3.88,3.88,0,0,0-.58-.23,5,5,0,0,0-.85-.21,6.33,6.33,0,0,0-5.3,1.62h0a8.48,8.48,0,0,0-1.88,6.26,10.42,10.42,0,0,0,3.86,7.13,16.13,16.13,0,0,0,8.74,3.51,35.64,35.64,0,0,0,10.38-.63,46.92,46.92,0,0,0,15.3-5.92,46.57,46.57,0,0,1,6.32-3.27,16.8,16.8,0,0,1,6-1.23,17.91,17.91,0,0,1,8.62,2,30,30,0,0,1,2.79,1.77,12.26,12.26,0,0,0-2.69-2,17.64,17.64,0,0,0-8.73-2.23,17.22,17.22,0,0,0-6.16,1.19,47.17,47.17,0,0,0-6.39,3.27,47.22,47.22,0,0,1-15.16,5.81,35.41,35.41,0,0,1-10.23.65,15.75,15.75,0,0,1-8.49-3.36,10.05,10.05,0,0,1-3.76-6.81,8.14,8.14,0,0,1,1.72-6h0a6.21,6.21,0,0,1,5.06-1.67A10.81,10.81,0,0,1,507.87,171.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.72,162.49a6,6,0,0,0,.37,2.36,9.92,9.92,0,0,0,4.14,5,12.41,12.41,0,0,0,4.19,1.74,17.78,17.78,0,0,0,5.2.27c3.67-.27,7.51-1.53,11.54-2.57s8.06-1.59,11.54-.66a15,15,0,0,1,7.84,5.09,15.59,15.59,0,0,1,3,5.64c.4,1.47.45,2.33.52,2.32a4.77,4.77,0,0,0,0-.62,12.43,12.43,0,0,0-.29-1.75,15.08,15.08,0,0,0-2.91-5.83,15.29,15.29,0,0,0-8-5.33c-3.6-1-7.74-.43-11.79.62s-7.86,2.31-11.45,2.6a17.62,17.62,0,0,1-5.07-.21,12.45,12.45,0,0,1-4.08-1.62,10,10,0,0,1-4.14-4.74A14.24,14.24,0,0,1,513.72,162.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.83,228.85a11.38,11.38,0,0,0,.81,3,3.67,3.67,0,0,0,2.25,2,3.28,3.28,0,0,0,3-.91,5.31,5.31,0,0,0,1.41-2.94c.16-1,0-2.25-1-2.57a2.56,2.56,0,0,0-1.23,0l-5.54,1",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.8,233.05a7.8,7.8,0,0,0,2.76.52,3.92,3.92,0,0,0,2.58-1.18,4.16,4.16,0,0,0,1.11-3.23,3.64,3.64,0,0,0-.2-.88c-.13-.27-.09-.25-.32-.28s-.59,0-.89.05l-.93.07c-1.2.09-2.28.16-3.19.21a9.52,9.52,0,0,1-3-.06,10.17,10.17,0,0,1,2.91-.6c.9-.13,2-.26,3.17-.4l.92-.1a9,9,0,0,1,1-.09,1.25,1.25,0,0,1,.73.26,1.46,1.46,0,0,1,.41.61,4.34,4.34,0,0,1,.26,1.12,4.91,4.91,0,0,1-1.43,3.93,4.47,4.47,0,0,1-3.17,1.23,4.14,4.14,0,0,1-2.18-.61C520,233.34,519.77,233.09,519.8,233.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.84,249.3s10.08,3.82,19.89,1c0,0-7.4,6.21-20.9,3.83Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.22,392.67a11.59,11.59,0,0,1-1.38-1.06c-.43-.35-1-.78-1.61-1.24s-1.35-1-2.2-1.55-1.73-1.15-2.76-1.72-2.12-1.17-3.29-1.77a51.32,51.32,0,0,0-16.32-4.88c-1.31-.14-2.55-.3-3.72-.33s-2.26-.08-3.25-.07-1.9.06-2.69.09-1.47.09-2,.15a10.53,10.53,0,0,1-1.73.12,13.16,13.16,0,0,1,1.71-.32,20,20,0,0,1,2-.24c.79-.06,1.69-.17,2.7-.17s2.1-.06,3.28,0,2.44.16,3.76.28a54.7,54.7,0,0,1,8.46,1.74,53,53,0,0,1,8,3.19c1.17.62,2.3,1.19,3.29,1.83s1.93,1.21,2.75,1.79,1.54,1.14,2.17,1.62,1.15.94,1.56,1.32A10.54,10.54,0,0,1,530.22,392.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.45,341.31l8.2-35.53c3.14-13.36,6.86-26.2,13.11-27.72v4.13L490.08,383.7s-16.71,19-38,8.46c-6.66-3.31-18.81-26.56-18.81-26.56S405,315.16,406.18,312.87s18.45-24.55,20.21-25.66Z",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.83,268c16.3,3.12,34.65,12.63,43.1,37,3.08,8.9,25.52,74.51,25.52,74.51l-38.27-.8L580,365.2l3,21.95,2.59,31.3-96.64,1.63.68-47.16.93-93.8s1.08-1.42,17.75-10.61C518.65,262.8,555.83,268,555.83,268Z",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.47,330.74c1.59,19.8,3.41,25.92,5,45.72a17.58,17.58,0,0,0,1,5.5,6,6,0,0,0,4,3.65c2.82.57,6.48,2.61,7.27-.15l-2.67-19.07a37.61,37.61,0,0,0-2.64-8.05c-5.93-13.17-8.12-13.94-12-27.6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M508.3,278.66l.32-2.06,3.09-19.76a2.3,2.3,0,0,1,2.46-1.94l38.05,3.18a4.37,4.37,0,0,1,4,4.68l-.85,11.48-11.88,15.5-17.11,2.67",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.19,315.81c.15,0,.26,15.48.26,34.57s-.11,34.57-.26,34.57-.26-15.48-.26-34.57S489.05,315.81,489.19,315.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587,381.89s0-.07-.12-.22-.19-.4-.32-.68l-1.16-2.63-4.17-9.71-13.59-32.11c-2.64-6.28-5.15-12.26-7.43-17.71a33.36,33.36,0,0,1-2.46-8,44.13,44.13,0,0,1-.66-7.3,29.44,29.44,0,0,1,1.52-10.45l.31-.83.35-.7a6.14,6.14,0,0,1,.6-1.06l.42-.62a1.75,1.75,0,0,1,.16-.2,20.55,20.55,0,0,0-1.65,3.48,30.24,30.24,0,0,0-1.34,10.38,38.16,38.16,0,0,0,3.19,15.15l7.47,17.69,13.45,32.17,4,9.77,1.07,2.67.27.7A1.21,1.21,0,0,1,587,381.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.69,271.49a12.53,12.53,0,0,1-1.11,1,17.19,17.19,0,0,1-3.65,2.13,27.4,27.4,0,0,1-6.42,1.8,79.61,79.61,0,0,1-8.8.87c-3.28.14-6.86.08-10.7.15a49.52,49.52,0,0,0-12.1,1.48,22.3,22.3,0,0,0-11.38,6.71,15.71,15.71,0,0,0-3.16,6.24,13.36,13.36,0,0,0,.12,7.15,11.35,11.35,0,0,0,1.67,3.2,8.43,8.43,0,0,0,2.7,2.28,5.88,5.88,0,0,0,3.34.7,4.57,4.57,0,0,0,2.94-1.5,8,8,0,0,0,1.48-6.33,10.39,10.39,0,0,0-1-3.12,15.25,15.25,0,0,0-1.77-2.69,18.84,18.84,0,0,0-10.26-6.07,21.79,21.79,0,0,0-10.49.12,28.76,28.76,0,0,0-8,3.43,38.24,38.24,0,0,0-5.32,4c-1.37,1.2-2.34,2.24-3,2.92l-.74.8a1.84,1.84,0,0,1-.27.26,32.57,32.57,0,0,1,3.9-4.13,36,36,0,0,1,5.3-4.06,28.71,28.71,0,0,1,8.1-3.54,22,22,0,0,1,10.68-.18,19.21,19.21,0,0,1,10.53,6.19A15.68,15.68,0,0,1,522.1,294a10.82,10.82,0,0,1,1,3.27,10.5,10.5,0,0,1-.06,3.49,6.93,6.93,0,0,1-1.53,3.25,5.07,5.07,0,0,1-3.26,1.67,6.33,6.33,0,0,1-3.64-.75,9,9,0,0,1-2.87-2.42,11.85,11.85,0,0,1-1.76-3.36,13.8,13.8,0,0,1-.12-7.43,16,16,0,0,1,3.27-6.45,22.88,22.88,0,0,1,11.64-6.85A49.71,49.71,0,0,1,537,277c3.85-.06,7.43,0,10.69-.09a80.12,80.12,0,0,0,8.77-.79,28.36,28.36,0,0,0,6.4-1.7,18.27,18.27,0,0,0,3.66-2c.4-.27.67-.52.87-.66A2.08,2.08,0,0,1,567.69,271.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.76,313.11a1.93,1.93,0,0,1-.43.07c-.28,0-.69.07-1.23.09a39.61,39.61,0,0,1-4.53-.11c-1.91-.14-4.17-.43-6.67-.78s-5.24-.72-8.14-.87a31.38,31.38,0,0,0-8.09.61,20.4,20.4,0,0,0-6.18,2.35,17.79,17.79,0,0,0-4.56,4,1.42,1.42,0,0,1,.22-.37,7.2,7.2,0,0,1,.72-1,13.78,13.78,0,0,1,3.43-3,20.1,20.1,0,0,1,6.26-2.5,30.69,30.69,0,0,1,8.23-.66c2.93.15,5.68.55,8.18.92s4.74.7,6.63.88,3.44.26,4.5.27A13.52,13.52,0,0,1,600.76,313.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.73,357.94a20.15,20.15,0,0,0-5.74-.49,31.14,31.14,0,0,0-6.67,1.19c-2.55.69-5.4,1.7-8.6,2.69a35.4,35.4,0,0,1-10.78,1.87,30.88,30.88,0,0,1-12.28-2.55,30.55,30.55,0,0,1-11.2-8.14,23.29,23.29,0,0,1-4-6.22,14.22,14.22,0,0,1-1.15-7.51,10.93,10.93,0,0,1,3.55-6.69,7.79,7.79,0,0,1,3.37-1.72,7.89,7.89,0,0,1,6.93,1.87,6,6,0,0,1,1.8,3.11,6.07,6.07,0,0,1-.27,3.51,8.44,8.44,0,0,1-1.87,2.87,14.91,14.91,0,0,1-5.49,3.49,16.76,16.76,0,0,1-3,.83c-.5.09-1,.2-1.49.27l-1.49.18a32.47,32.47,0,0,1-10.91-.77,34,34,0,0,1-8.43-3.24,31.12,31.12,0,0,1-5.61-3.88l-1-.87-.82-.83a13.89,13.89,0,0,1-1.24-1.34l-.72-.86a2.08,2.08,0,0,1-.22-.3,2.48,2.48,0,0,1,.27.27l.75.82a14.89,14.89,0,0,0,1.27,1.3l.83.81,1,.85a31.58,31.58,0,0,0,5.61,3.77,34,34,0,0,0,8.37,3.14,32.13,32.13,0,0,0,10.79.7l1.46-.18c.49-.08,1-.19,1.48-.28a16.19,16.19,0,0,0,2.93-.82,14.51,14.51,0,0,0,5.31-3.39,8,8,0,0,0,1.76-2.71,5.73,5.73,0,0,0,.25-3.23,6.26,6.26,0,0,0-4.67-4.48,7,7,0,0,0-6.61,1.51,10.33,10.33,0,0,0-3.37,6.37,13.87,13.87,0,0,0,1.1,7.23,23.22,23.22,0,0,0,3.88,6.09,30.14,30.14,0,0,0,11,8,30.67,30.67,0,0,0,12.09,2.56,35.16,35.16,0,0,0,10.68-1.8c3.19-1,6-1.94,8.63-2.61a30.92,30.92,0,0,1,6.73-1.11,19.94,19.94,0,0,1,2.49,0c.71.11,1.32.16,1.8.27l1.09.27A1.62,1.62,0,0,1,576.73,357.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.86,347.27c-.09,0-.55-1-1.52-2.68a26.1,26.1,0,0,0-10.67-9.95c-1.7-.86-2.82-1.24-2.79-1.33a3,3,0,0,1,.82.19,16.28,16.28,0,0,1,2.13.8,23.37,23.37,0,0,1,6.24,4.17,23,23,0,0,1,4.59,5.94,17.43,17.43,0,0,1,1,2.06A3.11,3.11,0,0,1,488.86,347.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.06,390.07s-.07-.08-.16-.25-.24-.44-.41-.75c-.36-.66-.88-1.65-1.52-2.93a68.54,68.54,0,0,1-4.58-11.27,36.42,36.42,0,0,1-1.43-8.29,25.86,25.86,0,0,1,.19-4.7,28.06,28.06,0,0,1,1.18-4.85,21.14,21.14,0,0,1,5.87-8.88,14.37,14.37,0,0,1,10.67-3.75,7.92,7.92,0,0,1,5.26,2.56,6.46,6.46,0,0,1,1.49,5.47,4.86,4.86,0,0,1-1.42,2.47,5.79,5.79,0,0,1-2.44,1.33,7.2,7.2,0,0,1-5.23-.63,11.94,11.94,0,0,1-3.81-3.25,17.52,17.52,0,0,1-2.41-4.07A18,18,0,0,1,450,340a17,17,0,0,1,2-6.65,17.36,17.36,0,0,1,3.14-4.2,16.32,16.32,0,0,1,2.57-2.09c.31-.21.57-.34.74-.44l.26-.13s-.32.23-.94.66a18.18,18.18,0,0,0-2.49,2.14,17.79,17.79,0,0,0-3,4.19,16.8,16.8,0,0,0-1.87,6.54,17.56,17.56,0,0,0,1.36,8.1,17.28,17.28,0,0,0,2.36,3.95,11.57,11.57,0,0,0,3.68,3.11,6.7,6.7,0,0,0,4.88.58,4.7,4.7,0,0,0,3.49-3.44,6,6,0,0,0-1.38-5,7.4,7.4,0,0,0-4.92-2.38,13.87,13.87,0,0,0-10.28,3.61,20.83,20.83,0,0,0-5.75,8.66,27.07,27.07,0,0,0-1.19,4.75,25.91,25.91,0,0,0-.21,4.62,36.65,36.65,0,0,0,1.36,8.21,73.11,73.11,0,0,0,4.4,11.28l1.43,3c.15.32.27.58.37.78S450.06,390.07,450.06,390.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.71,301.79s.05.14.09.41a12.18,12.18,0,0,1,.15,1.22,25.56,25.56,0,0,1,0,4.49,28.54,28.54,0,0,1-16.12,23.43,25.71,25.71,0,0,1-4.19,1.61c-.5.16-.91.23-1.18.3s-.42.08-.42.06a12.79,12.79,0,0,1,1.54-.55,31.56,31.56,0,0,0,4.09-1.75,29.27,29.27,0,0,0,15.92-23.14,32.55,32.55,0,0,0,.17-4.44A12.7,12.7,0,0,1,437.71,301.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.51,345.15a14.62,14.62,0,0,0-3.86,3.52c-1,1.29-2,3-3.13,4.8a37,37,0,0,1-4.27,5.65A36,36,0,0,1,588,366.83a30.06,30.06,0,0,1-3.58,1.53,7.84,7.84,0,0,1-1.38.4,7.66,7.66,0,0,1,1.3-.59c.84-.37,2.06-.89,3.49-1.67a38.5,38.5,0,0,0,10-7.73,38,38,0,0,0,4.25-5.55,52.18,52.18,0,0,1,3.25-4.78,12.63,12.63,0,0,1,2.87-2.65,6.25,6.25,0,0,1,.93-.51C609.39,345.18,609.51,345.13,609.51,345.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.47,269.2a1.59,1.59,0,0,1-.46.12l-1.33.24c-1.16.19-2.84.44-4.91.72-4.16.56-9.92,1.22-16.31,1.69a81.06,81.06,0,0,1-9,.32,25.52,25.52,0,0,1-7.29-1.25,16.19,16.19,0,0,1-4.45-2.25,10.94,10.94,0,0,1-1.06-.85c-.22-.22-.33-.33-.32-.35s.52.4,1.49,1a17.85,17.85,0,0,0,4.45,2.06,25.91,25.91,0,0,0,7.2,1.12,89,89,0,0,0,9-.36c6.37-.47,12.13-1.06,16.29-1.53l4.93-.56A12.65,12.65,0,0,1,555.47,269.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624,386.59a26.87,26.87,0,0,1-26.11,32l-75.75-.84,2-24.53L589,383.48",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.78,394.29c-.35.11-4.72-1.85-8.64-3.66a28.24,28.24,0,0,0-13.3-2.58l-18.06.92s1.11,3,3,4S505,394.29,505,394.29l-.58.59a13,13,0,0,1-9,3.94l-1.73,0a16.78,16.78,0,0,1-3.77-.74l-4.45-1.8c-1.35-.6-2.77-.51-3.36.85s-.14,2.92,3.54,4.77c2.05,1,9.67,3.67,9.67,3.67a17.94,17.94,0,0,0,.45,3.22c.33,1.11,3.32,2.22,3.32,2.22a39.84,39.84,0,0,0,2.66,4.76c.35.4,3.06,1.25,5.95,2.06a25.69,25.69,0,0,0,14.23-.11l6.88-2.06v-21",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.08,408a20.47,20.47,0,0,1-9.11-2.4c0-.12,2,.64,4.53,1.29S504.09,407.85,504.08,408Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.44,412.21a4.62,4.62,0,0,1-2.54-.19,4.69,4.69,0,0,1-2.28-1.12,15.08,15.08,0,0,1,2.4.69A16.26,16.26,0,0,1,503.44,412.21Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.74,392.66a7.68,7.68,0,0,1-1.39,1.49,22.26,22.26,0,0,1-3.94,3,15.52,15.52,0,0,1-4.61,1.78,6.65,6.65,0,0,1-2,.22,26.33,26.33,0,0,0,6.42-2.39,30.7,30.7,0,0,0,3.95-2.83A11.38,11.38,0,0,1,506.74,392.66Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.62,391l-1.84,27.74,71.35,0a26.65,26.65,0,0,0,13.75-3.81h0a26.68,26.68,0,0,0,12.44-28,82.08,82.08,0,0,0-4.6-15.39l-35.88,5.91,1.15,4.46Z",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.52,379.58a5.82,5.82,0,0,1-.72.16l-2.09.38L593,381.4l-25.36,4-25.39,3.89-7.7,1.12-2.1.28a6.5,6.5,0,0,1-.74.06,3.54,3.54,0,0,1,.73-.17l2.08-.37,7.68-1.29,25.36-4L593,381l7.7-1.12,2.1-.28A3.4,3.4,0,0,1,603.52,379.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,418.76c-.13,0,.43-2,.5-5.27a22.76,22.76,0,0,0-.11-2.66,25,25,0,0,0-.44-3,27.93,27.93,0,0,0-2.32-6.58,30.1,30.1,0,0,0-3.9-5.8l-1-1.17c-.34-.38-.71-.71-1.05-1.05-.67-.69-1.38-1.24-2-1.77-2.55-2-4.36-3-4.3-3.09a7.73,7.73,0,0,1,1.27.65,13.44,13.44,0,0,1,1.44.87c.53.38,1.19.75,1.82,1.29a23,23,0,0,1,2.06,1.74c.35.34.74.66,1.09,1l1.09,1.18a29.33,29.33,0,0,1,4,5.87,27.7,27.7,0,0,1,2.32,6.72,22.39,22.39,0,0,1,.4,3.09,19,19,0,0,1,0,2.7,17.58,17.58,0,0,1-.2,2.23,11.09,11.09,0,0,1-.29,1.65A8.43,8.43,0,0,1,567,418.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.44,416.67a15,15,0,0,1-3.31-.39,17.13,17.13,0,0,1-3.7-1.31,14.69,14.69,0,0,1-4.17-3.1,13.28,13.28,0,0,1-3.07-5.5,14.79,14.79,0,0,1-.53-3.5,13.6,13.6,0,0,1,.3-3.73,11,11,0,0,1,1.48-3.67,8.3,8.3,0,0,1,3-2.86,7.44,7.44,0,0,1,4.19-1,5.59,5.59,0,0,1,3.91,2,5.48,5.48,0,0,1,1.32,4.21,5,5,0,0,1-2.46,3.52,11.72,11.72,0,0,1-7.88,1.08,16.45,16.45,0,0,1-13.91-15.76,11.82,11.82,0,0,1,.28-3.32,27.82,27.82,0,0,0-.08,3.31,17,17,0,0,0,2.85,8.42A16.32,16.32,0,0,0,599.58,402a11.29,11.29,0,0,0,7.54-1,4.5,4.5,0,0,0,2.22-3.15,5.22,5.22,0,0,0-4.77-5.65,6.91,6.91,0,0,0-3.89.89,9,9,0,0,0-4.25,6.18,13.12,13.12,0,0,0-.31,3.62,14.37,14.37,0,0,0,.49,3.39,12.85,12.85,0,0,0,2.92,5.37,14.59,14.59,0,0,0,4,3.09,17.57,17.57,0,0,0,3.62,1.37C609.25,416.58,610.45,416.6,610.44,416.67Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.41,114.47H148.72a39.38,39.38,0,0,0-39.38,39.38v63.68H70.79l38.55,38.55v43.29a39.38,39.38,0,0,0,39.38,39.38H327.41a39.38,39.38,0,0,0,39.38-39.38V153.85A39.38,39.38,0,0,0,327.41,114.47Z",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.41,121.2c-1.13,2.93.81,6.12,3,8.38s4.81,4.4,5.5,7.46c.57,2.57-.38,5.24-.15,7.86s1.68,5.09,2.5,7.65c1.49,4.64.89,9.71-.44,14.4a26.47,26.47,0,0,1-5.36,10.61,14.14,14.14,0,0,1-10.48,5,4.14,4.14,0,0,1-3.1-1.12,5,5,0,0,1-.89-2.75,268.13,268.13,0,0,1,0-60.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,186.09c8.7-.38,16.74,7.95,16.05,16.63,8.81,2.15,15,11.84,13.31,20.74-.57,2.94-1.88,5.74-2.06,8.72-.2,3.26,1,6.43,1.59,9.63a30.34,30.34,0,0,1-1.74,17.36c-1.37,3.31-3.93,6.73-7.51,6.83a7.4,7.4,0,0,1-6-3.53,18.61,18.61,0,0,1-2.42-6.83c-1.55-7.82-2-15.85-4.16-23.52S253,216.89,246.07,213c-3.83-2.16-8.43-3.18-11.48-6.35a12.47,12.47,0,0,1-2.25-12.9,16.44,16.44,0,0,1,9.8-9.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.08,128.37c-.1-3.72,3.33-6.59,6.79-8s7.31-1.88,10.39-4c2.74-1.84,4.57-4.71,6.88-7a22.89,22.89,0,0,1,38.5,10.5c1.33,5.29.42,11.55-3.75,15.07-4.84,4.08-12,3.17-18.23,1.9s-13.23-2.52-18.41,1.13c-3.12,2.19-4.92,5.77-6.83,9.08s-4.3,6.68-7.91,7.93-8.52-.91-8.66-4.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.74,129.13a6.22,6.22,0,0,0-5.55,6.32h0l3.71,84c.16,9.92,14.66,15.49,25.28,15.24h0c10.73-.25,11.07-5.51,11.21-14.95.22-15.76.2-21.68.21-21.59s13.55-2.28,16.32-20c1.37-8.79.9-23.21.13-35-.69-10.61-7.75-23.61-18.32-22.47Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,154.29a2.27,2.27,0,0,1-2.18,2.29,2.16,2.16,0,0,1-2.34-2,2.26,2.26,0,0,1,2.18-2.29A2.16,2.16,0,0,1,255,154.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.94,150.69c-.28.3-2-1-4.44-1s-4.23,1.24-4.5.94c-.13-.13.16-.67.94-1.24a6.19,6.19,0,0,1,3.59-1.11,6,6,0,0,1,3.54,1.13C254.82,150,255.08,150.56,254.94,150.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.55,154.29a2.27,2.27,0,0,1-2.18,2.29,2.16,2.16,0,0,1-2.34-2,2.26,2.26,0,0,1,2.18-2.29A2.16,2.16,0,0,1,231.55,154.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,151.2c-.28.3-2-1-4.44-1s-4.23,1.24-4.49.94c-.13-.13.15-.67.93-1.24a6.22,6.22,0,0,1,3.59-1.12,6,6,0,0,1,3.54,1.14C230.83,150.53,231.09,151.07,231,151.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.85,169.28c0-.14,1.5-.4,4-.72.62-.07,1.21-.2,1.32-.62a3.27,3.27,0,0,0-.42-1.85l-1.86-4.74c-2.57-6.75-4.44-12.3-4.16-12.4s2.58,5.29,5.15,12l1.78,4.77a3.67,3.67,0,0,1,.33,2.44,1.58,1.58,0,0,1-1,.92,3.9,3.9,0,0,1-1,.14C241.39,169.4,239.86,169.42,239.85,169.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,198.16a45,45,0,0,1-23.7-6.27s5.77,12.14,23.47,10.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83,175.16a4.39,4.39,0,0,0-4-1.62,4,4,0,0,0-2.77,1.49,2.54,2.54,0,0,0-.18,2.91,2.93,2.93,0,0,0,3.2.8,9.14,9.14,0,0,0,3.11-1.87,2.66,2.66,0,0,0,.7-.72.81.81,0,0,0,0-.91",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,171c.4,0,.41,2.63,2.68,4.5s5.09,1.58,5.11,2c0,.17-.63.52-1.82.55a6.59,6.59,0,0,1-4.27-1.47,5.75,5.75,0,0,1-2.07-3.78C232.19,171.63,232.49,171,232.67,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,146.92c-.24.67-2.68.36-5.54.71s-5.18,1.14-5.56.54c-.17-.28.23-.91,1.16-1.55a9.72,9.72,0,0,1,8.46-1C231.61,146.09,232.14,146.61,232,146.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,143.63c-.43.55-2.11,0-4.14,0s-3.73.38-4.12-.2c-.18-.28.09-.83.84-1.36a6,6,0,0,1,6.65.19C254,142.79,254.21,143.36,254,143.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.39,187.31A15.69,15.69,0,0,0,213.07,170c-.55-4.35-2.89-8.76-1.38-12.88,2-5.43,9.61-7.1,11.63-12.53,1.17-3.15.12-6.84,1.45-9.93,1.25-2.9,4.31-4.57,7.29-5.65s6.16-1.82,8.66-3.76,4.05-5.6,2.44-8.33a167.5,167.5,0,0,0-38.64,9.39c-2.89,1.08-5.92,2.38-7.63,4.94-1.8,2.72-1.71,6.22-1.56,9.48.74,15.88-1.68,30.75-.94,46.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.18,182.33a1,1,0,0,1-.29-.09,3.67,3.67,0,0,1-.81-.4,5.87,5.87,0,0,1-2.2-2.6,8.72,8.72,0,0,1-.58-5.37,17.09,17.09,0,0,1,3.21-6.43c1.55-2.16,3.52-4.35,4.86-7.14a11,11,0,0,0,1.17-4.56,15.17,15.17,0,0,0-1-4.92,14.94,14.94,0,0,1-1.05-5.34,12,12,0,0,1,5.75-9.66,13.76,13.76,0,0,1,5.83-1.66,24.53,24.53,0,0,0,5.83-1,7.61,7.61,0,0,0,4.1-3.69,28.28,28.28,0,0,0,1.94-5.22,28.25,28.25,0,0,1,2-5,18.91,18.91,0,0,1,6.63-7.45,14.34,14.34,0,0,1,8.39-2.18,10.79,10.79,0,0,1,6.61,2.71,10.44,10.44,0,0,1,2.95,4.54,8.41,8.41,0,0,1,.41,3.4,5.13,5.13,0,0,1-.2,1.18s.07-.41.1-1.19a8.85,8.85,0,0,0-.5-3.33,10.38,10.38,0,0,0-9.39-6.94,14,14,0,0,0-8.14,2.18,18.48,18.48,0,0,0-6.44,7.3,27.54,27.54,0,0,0-1.94,5,28.5,28.5,0,0,1-2,5.31,9.09,9.09,0,0,1-1.79,2.36,7.59,7.59,0,0,1-2.58,1.57,24.61,24.61,0,0,1-6,1.06,13.2,13.2,0,0,0-5.62,1.59,11.48,11.48,0,0,0-5.51,9.22,14.68,14.68,0,0,0,1,5.18,15.31,15.31,0,0,1,1.05,5.08,11.48,11.48,0,0,1-1.24,4.74c-1.4,2.86-3.39,5-4.95,7.17a16.76,16.76,0,0,0-3.22,6.27,8.48,8.48,0,0,0,.47,5.22,6,6,0,0,0,2.08,2.61C189.78,182.19,190.19,182.29,190.18,182.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,105.22a1.64,1.64,0,0,1,.69.21,7.06,7.06,0,0,1,1.67,1,8.57,8.57,0,0,1,1.75,11.71,7.6,7.6,0,0,1-1.3,1.45c-.36.3-.58.43-.6.4a24.86,24.86,0,0,0,1.59-2,8.63,8.63,0,0,0-1.67-11.23A22.76,22.76,0,0,0,241.57,105.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.75,226.59a14.88,14.88,0,0,0,.51-1.88,8.66,8.66,0,0,0-.87-5.09,11.81,11.81,0,0,0-5.58-5.2,23.23,23.23,0,0,0-4.35-1.55c-1.56-.4-3.21-.73-4.86-1.27a11,11,0,0,1-4.47-2.44,7.46,7.46,0,0,1-2.11-4.24c-.27-1.49-.36-2.9-.69-4.16a8.16,8.16,0,0,0-1.61-3.18,9.19,9.19,0,0,0-4.28-2.91c-1.19-.36-1.9-.36-1.9-.42a2.58,2.58,0,0,1,.51,0,8.32,8.32,0,0,1,1.45.23,9.07,9.07,0,0,1,4.5,2.87,8.45,8.45,0,0,1,1.75,3.31c.36,1.31.47,2.74.75,4.18a6.92,6.92,0,0,0,2,4,10.64,10.64,0,0,0,4.27,2.31c1.61.52,3.26.86,4.83,1.27A22.34,22.34,0,0,1,275,214a12,12,0,0,1,5.7,5.47,8.62,8.62,0,0,1,.74,5.29,6.26,6.26,0,0,1-.45,1.39A2.42,2.42,0,0,1,280.75,226.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,195.27c-9-2.4-16.7-11.17-19.84-19.9s-3.14-18.26-2.33-27.5c.58-6.69,1.76-13.77,6.2-18.81,6.7-7.6,14-11.48,24.08-11.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.13,214.77l-8.35-2.1a4.75,4.75,0,0,0,1.66-5.82,7.65,7.65,0,0,0-6.38-4.73L205,197.82a3,3,0,0,0-3.19,1.88q-2.53,6.44-.17,10.6h-.18l-7.34,1.46L181.68,321.5l81.48-3.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.15,213.09a8.61,8.61,0,0,1-1.53.3c-1,.16-2.43.33-4.21.51a98.36,98.36,0,0,1-27.89-1.39c-1.76-.35-3.17-.67-4.14-.93a8.13,8.13,0,0,1-1.49-.44,8.75,8.75,0,0,1,1.53.25c1,.19,2.41.46,4.17.76a115.46,115.46,0,0,0,27.79,1.38c1.78-.12,3.22-.25,4.22-.35A9.89,9.89,0,0,1,244.15,213.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,230.53a29.92,29.92,0,0,1,2.85-4.74,29.58,29.58,0,0,1,3.29-4.45,29.56,29.56,0,0,1-2.86,4.74A29.16,29.16,0,0,1,207.32,230.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.58,232.39a57.29,57.29,0,0,1-6.83-8.5,29.09,29.09,0,0,1,3.62,4.09A28.19,28.19,0,0,1,233.58,232.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38,246.34a30.79,30.79,0,0,1-1.23-5.46,28.81,28.81,0,0,1-.71-5.55,30.52,30.52,0,0,1,1.23,5.46A30.74,30.74,0,0,1,221.38,246.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,247.2a44,44,0,0,1-4.62,4.92,43.13,43.13,0,0,1-5,4.55,43.91,43.91,0,0,1,4.62-4.92A45.49,45.49,0,0,1,241.43,247.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.54,265.9a23.19,23.19,0,0,1-8.67-9.19c.14-.09,1.67,2.31,4.08,4.84S214.64,265.77,214.54,265.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.18,280.34c0,.15-2.28.88-4.92,2.29s-4.57,2.89-4.67,2.76a14.55,14.55,0,0,1,4.43-3.23A14.24,14.24,0,0,1,223.18,280.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.23,281.27a9.83,9.83,0,0,1-1.59-1.71c-.92-1.1-2.15-2.67-3.43-4.46s-2.36-3.46-3.11-4.7a9.94,9.94,0,0,1-1.1-2.06,11.49,11.49,0,0,1,1.41,1.86l3.23,4.6,3.29,4.54A11,11,0,0,1,237.23,281.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.64,293.59a28.58,28.58,0,0,1-6,1.4,29,29,0,0,1-6.15.61,48.42,48.42,0,0,1,6.07-1.12A51.76,51.76,0,0,1,238.64,293.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.89,211.54c-.07,0,.41-.6.82-1.66a8.82,8.82,0,0,0,.44-4.34,17.7,17.7,0,0,0-1.29-4.27,8.07,8.07,0,0,1-.68-1.76,5.92,5.92,0,0,1,1,1.61,13.86,13.86,0,0,1,1.47,4.34,8.13,8.13,0,0,1-.61,4.57A3.23,3.23,0,0,1,215.89,211.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,203.32a9.11,9.11,0,0,1,1.61,6.88c-.15,0-.17-1.59-.62-3.48S231,203.4,231.11,203.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,281.51l37.9-66.57,4.57-11.55s11.82-25.4,12.64-28c.95-3,2.62-3.24,3.7-2.82,1.68.67,2.22,3.17,1.48,5.76-.26.89-4.85,14.85-4.85,14.85a33.53,33.53,0,0,1,3.92-2.91c2.91-2,8.24-1.9,13.18-.14s6.16,2.69,5.57,4.63a2.58,2.58,0,0,1-1.59,1.57,5,5,0,0,1-3.65.08c-7.94-2.7-11.46.88-11.46.88l-.59,1.51s6-1.91,9.36.79a5,5,0,0,1,1.24,1.44,6.57,6.57,0,0,1,2.43,11.06,2.73,2.73,0,0,1-3,.76,3.35,3.35,0,0,1-1.13-1.31,5.78,5.78,0,0,0-.55-.75l-2.26,4s-5.57,8.7-7.57,12.77L333,297.09a18.4,18.4,0,0,1-24,10.65h0A18.41,18.41,0,0,1,299.76,281.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,214.71c1.34.88,3.19.28,4.39-.76s2-2.47,3.16-3.6c3.37-3.37,9-3.69,12.23-7.22.45-.49.85-1.24.46-1.78s-1.11-.44-1.71-.32l-15.51,3.07",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.29,204.1a6.65,6.65,0,0,1,1.64-.5c1.07-.27,2.63-.62,4.55-1l6.76-1.43,2-.41a3.16,3.16,0,0,1,2.37.08,1.34,1.34,0,0,1,.5,1.41,2.65,2.65,0,0,1-.6,1.14,10.22,10.22,0,0,1-1.75,1.54c-2.58,1.79-5.41,2.52-7.67,3.71a11.45,11.45,0,0,0-2.94,2c-.8.77-1.43,1.65-2.09,2.4a5.58,5.58,0,0,1-4.11,2.31c-1.19,0-1.68-.59-1.64-.6a4.65,4.65,0,0,0,1.62.25,5.41,5.41,0,0,0,3.64-2.37,32.2,32.2,0,0,1,2.05-2.52,12.09,12.09,0,0,1,3.09-2.22c2.33-1.26,5.15-2,7.53-3.7a10.14,10.14,0,0,0,1.58-1.39c.44-.49.59-1.08.28-1.25s-1-.09-1.69.05l-2,.37-6.8,1.25c-1.94.34-3.51.6-4.6.76A5.52,5.52,0,0,1,343.29,204.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.37,198.82a6.45,6.45,0,0,1,1.78-2.4,5,5,0,0,1,3-1,12.92,12.92,0,0,1,4,.66,20.33,20.33,0,0,0,4.06.92,6.54,6.54,0,0,0,3.4-.52,2.59,2.59,0,0,0,1.45-1.82,1.62,1.62,0,0,0,0-.85c-.06,0-.06.3-.21.8a2.43,2.43,0,0,1-1.4,1.5,6.66,6.66,0,0,1-3.19.36,22,22,0,0,1-3.94-1,12.78,12.78,0,0,0-4.14-.64,5.28,5.28,0,0,0-3.23,1.2,4.58,4.58,0,0,0-1.35,1.89C360.35,198.51,360.33,198.81,360.37,198.82Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.32,177.33a17,17,0,0,0-.94,2.77c-.59,1.92-1.29,4.2-2.07,6.72s-1.55,4.78-2.17,6.69a15.93,15.93,0,0,0-.83,2.8,14.22,14.22,0,0,0,1.22-2.66c.66-1.68,1.5-4,2.34-6.65s1.49-5,1.91-6.79A13.93,13.93,0,0,0,360.32,177.33Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,203a3.23,3.23,0,0,0,.92,0,2.71,2.71,0,0,1,2.18.58,1.47,1.47,0,0,1,.35,1.4,7.54,7.54,0,0,1-.71,1.76,3.28,3.28,0,0,0-.37,2.3,2.81,2.81,0,0,0,1.78,1.79,3.16,3.16,0,0,0,2.49-.25,3.89,3.89,0,0,0,1.65-1.61,12.87,12.87,0,0,0,1.1-3.6,7.37,7.37,0,0,0,0-2.53,1.64,1.64,0,0,0-.35-.86c-.05,0,.08.32.13.89a8.83,8.83,0,0,1-.21,2.43,13.9,13.9,0,0,1-1.16,3.41,3.13,3.13,0,0,1-3.48,1.57,2.22,2.22,0,0,1-1.42-1.4,2.76,2.76,0,0,1,.31-1.91,8.27,8.27,0,0,0,.7-1.91,1.9,1.9,0,0,0-.55-1.77,2.85,2.85,0,0,0-2.5-.52A2.76,2.76,0,0,0,362.51,203Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.05,210s-.19.26-.17.82a2.53,2.53,0,0,0,1.16,1.95,3.38,3.38,0,0,0,3.37,0,5.51,5.51,0,0,0,2.54-3.24,6.66,6.66,0,0,0,0-4.12,6.36,6.36,0,0,0-1.85-2.8,6,6,0,0,0-1.93-1.16,1.83,1.83,0,0,0-.81-.18,10.82,10.82,0,0,1,2.46,1.64,6.27,6.27,0,0,1,1.58,6.44,5.15,5.15,0,0,1-2.25,2.95,3,3,0,0,1-2.89.08,2.43,2.43,0,0,1-1.16-1.63C369,210.31,369.1,210,369.05,210Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.43,216.28a2.39,2.39,0,0,0-1.34-.41,5.5,5.5,0,0,0-3.48.83l.43.29a16.1,16.1,0,0,0,.28-2c.35-3.86-.88-6.84-1-6.76a31.19,31.19,0,0,1,.43,6.71,17.7,17.7,0,0,1-.25,1.91l-.12.65.55-.37a5.78,5.78,0,0,1,3.15-.94C355.91,216.21,356.41,216.35,356.43,216.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.32,192.56c-.16,0,.06,1.2,1.12,2.12s2.25,1,2.25.83-.95-.46-1.86-1.27S364.48,192.5,364.32,192.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,336.75l39.65.39L279,308.37l2.23,5.43a27.31,27.31,0,0,0,25.27,16.95h0c12.54,0,21.21-9.33,26.51-20.69,12.4-26.56,24.35-69.33,24.35-69.33l-24.17-21.24c-17.5,33.1-33.94,61.84-33.94,61.84s-4.75-14.43-8.42-27.31-3.64-19.64-9.27-26.06c-8.67-9.88-21-12.33-32.48-15.29l-.43,53.44L246,336.75",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,297,272.83,311l3.51,27.74H165.64a21.8,21.8,0,0,1-22-23.52c1.59-20.22,3.32-45.12,4.64-55.65,1-8.21,4.3-16.7,8.17-24,5.59-10.52,24.22-24,40.55-24.7l3.09,68.77",
    style: {
      fill: "#BAE1FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246,336.75l39.65.39L279,308.37l2.23,5.43a27.31,27.31,0,0,0,25.27,16.95h0c12.54,0,21.21-9.33,26.51-20.69,12.4-26.56,24.35-69.33,24.35-69.33l-24.17-21.24c-17.5,33.1-33.94,61.84-33.94,61.84s-4.75-14.43-8.42-27.31-3.64-19.64-9.27-26.06c-8.67-9.88-21-12.33-32.48-15.29l-.43,53.44L246,336.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.63,297l65.12,11.94a6.82,6.82,0,0,1,5.43,5.29l5.16,24.57H165.64a21.8,21.8,0,0,1-22-23.52c1.59-20.22,3.32-45.12,4.64-55.65,1-8.21,4.3-16.7,8.17-24,5.59-10.52,24.22-24,40.55-24.7l3.09,68.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186.88,294.94a2.82,2.82,0,0,1,0-.66c0-.49,0-1.12,0-1.89,0-1.71,0-4.07,0-7,0-5.87-.11-14-.56-22.93-.23-4.48-.52-8.74-.83-12.6a51.69,51.69,0,0,0-1.45-10.16,14.55,14.55,0,0,0-3.18-6A22.68,22.68,0,0,0,179,232a7.74,7.74,0,0,1,2.05,1.53,14.1,14.1,0,0,1,3.39,6.07A50.16,50.16,0,0,1,186,249.86c.34,3.87.64,8.13.87,12.61.46,9,.51,17.09.41,23-.06,2.94-.14,5.32-.21,7l-.11,1.89A2.5,2.5,0,0,1,186.88,294.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,313a11,11,0,0,0-2.63-2.13,16.62,16.62,0,0,0-3.69-1.47c-1.49-.43-3.24-.76-5.17-1.15-7.72-1.58-18.37-3.77-30.17-6s-22.54-4-30.31-5.24l-9.21-1.47-2.5-.42a5.43,5.43,0,0,1-.87-.18,5.16,5.16,0,0,1,.88.08l2.52.32c2.18.29,5.34.73,9.23,1.31,7.79,1.16,18.54,2.88,30.35,5.09s22.46,4.45,30.15,6.11c1.93.42,3.68.78,5.18,1.24a15.93,15.93,0,0,1,3.71,1.58,8,8,0,0,1,2,1.6,4,4,0,0,1,.42.51C271.39,312.9,271.44,313,271.43,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,294.94c0,.09-1.33.4-3.39,1.24a30.07,30.07,0,0,0-3.5,1.72,31.32,31.32,0,0,0-3.89,2.74A30.6,30.6,0,0,0,173,304a28.24,28.24,0,0,0-2.3,3.14c-1.18,1.89-1.72,3.17-1.81,3.13a3.75,3.75,0,0,1,.31-.93,20.35,20.35,0,0,1,1.18-2.39,26.51,26.51,0,0,1,2.25-3.26,25.75,25.75,0,0,1,7.4-6.21,23.82,23.82,0,0,1,3.59-1.65,18.51,18.51,0,0,1,2.56-.75A3.33,3.33,0,0,1,187.1,294.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,312.22a4.3,4.3,0,0,1-.15-.69c-.08-.5-.19-1.16-.32-2-.28-1.73-.65-4.23-1.07-7.33-.84-6.19-1.86-14.77-2.72-24.27s-1.37-18.12-1.65-24.37c-.14-3.12-.22-5.65-.26-7.4q0-1.25,0-2a3.75,3.75,0,0,1,0-.7,3,3,0,0,1,.08.7l.13,2c.11,1.8.25,4.31.43,7.38.37,6.24.95,14.85,1.8,24.34s1.82,18.07,2.57,24.27c.37,3.06.68,5.55.9,7.35.09.83.17,1.49.23,2A2.85,2.85,0,0,1,280.33,312.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,301.47s-.23-.22-.58-.66a19.19,19.19,0,0,1-1.33-2,26.35,26.35,0,0,1-3.55-15.16,16.84,16.84,0,0,1,.32-2.37,3.33,3.33,0,0,1,.22-.85c.09,0-.1,1.24-.17,3.24a29.82,29.82,0,0,0,3.5,15C303.62,300.4,304.35,301.41,304.27,301.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,257.78s-.13.05-.37.08a9.33,9.33,0,0,1-1.09.11,16.51,16.51,0,0,1-4-.32,28.49,28.49,0,0,1-5.69-1.78c-2.07-.86-4.27-2-6.57-3.11A49.42,49.42,0,0,0,162.2,250a22.63,22.63,0,0,0-5.74-1.13,18.62,18.62,0,0,0-5.37.61,1.22,1.22,0,0,1,.35-.16,7,7,0,0,1,1-.35,13.72,13.72,0,0,1,4-.46,21.81,21.81,0,0,1,5.88,1,45.66,45.66,0,0,1,6.74,2.78c2.31,1.14,4.49,2.26,6.53,3.13a30.57,30.57,0,0,0,5.58,1.86A24.87,24.87,0,0,0,186.59,257.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,255.35a35.67,35.67,0,0,1-5.88,1.26,33.61,33.61,0,0,1-6,.75A35.67,35.67,0,0,1,193,256.1,33.52,33.52,0,0,1,199,255.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.14,276.81a7.63,7.63,0,0,1-1.45.63c-.95.37-2.34.87-4.07,1.43a104.92,104.92,0,0,1-13.82,3.42c-2.74.48-5.37.83-7.77,1.07a31.53,31.53,0,0,1-6.42.17,11,11,0,0,1-4.16-1.19,6.6,6.6,0,0,1-1-.64,1.56,1.56,0,0,1-.31-.28s.48.31,1.39.74a11.47,11.47,0,0,0,4.11,1,33.07,33.07,0,0,0,6.33-.28c2.39-.27,5-.63,7.73-1.11a127.14,127.14,0,0,0,13.8-3.25c1.74-.52,3.14-1,4.11-1.27A10.76,10.76,0,0,1,186.14,276.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,282.08a29.28,29.28,0,0,1-5.45.35,29,29,0,0,1-5.45-.17,29.28,29.28,0,0,1,5.45-.35A29,29,0,0,1,198.67,282.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.21,327.64a2,2,0,0,1,.11-.54c.1-.4.24-.89.4-1.5l.3-1.08c.13-.39.3-.8.46-1.25a30.39,30.39,0,0,1,1.24-3l.81-1.71c.29-.6.66-1.18,1-1.8a44.15,44.15,0,0,1,2.46-3.81,45.57,45.57,0,0,1,15.57-13.55,43.63,43.63,0,0,1,4.12-1.91c.67-.25,1.29-.54,1.92-.74l1.81-.57a28.38,28.38,0,0,1,3.16-.81c.47-.1.9-.21,1.3-.28l1.12-.15,1.54-.19a1.84,1.84,0,0,1,.54,0,2.19,2.19,0,0,1-.53.13l-1.52.29-1.1.19-1.29.32c-.92.25-2,.46-3.11.88l-1.78.6c-.62.21-1.24.5-1.89.76a44.6,44.6,0,0,0-4.06,1.93,50.94,50.94,0,0,0-8.45,5.86,51.48,51.48,0,0,0-7,7.55c-.9,1.3-1.79,2.52-2.47,3.75-.35.61-.72,1.18-1,1.77l-.84,1.68c-.57,1.06-.92,2.08-1.3,3-.17.44-.35.85-.49,1.23l-.35,1.06-.49,1.47A2.12,2.12,0,0,1,147.21,327.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.36,296.92a18,18,0,0,0-4.1,5.16,24.86,24.86,0,0,0-2.3,6.79,70.44,70.44,0,0,0-1,8.79,63.13,63.13,0,0,1-1,8.85,24.48,24.48,0,0,1-2.51,6.85,15.07,15.07,0,0,1-3,3.85,8.47,8.47,0,0,1-1.05.83c-.25.17-.39.26-.4.24a17.56,17.56,0,0,0,4.18-5.1,24.92,24.92,0,0,0,2.36-6.76,65.07,65.07,0,0,0,1-8.79,64.92,64.92,0,0,1,1-8.86,24.4,24.4,0,0,1,2.44-6.86,15.5,15.5,0,0,1,3-3.9,10,10,0,0,1,1-.84A1.79,1.79,0,0,1,197.36,296.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.43,338.91c-.14,0,0-8.62.37-19.24s.75-19.23.89-19.23,0,8.62-.37,19.25S214.57,338.92,214.43,338.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,337.43a6.6,6.6,0,0,1-.44-1.25,15.16,15.16,0,0,1-.41-1.5c-.13-.59-.31-1.26-.42-2a35.53,35.53,0,0,1-.53-5.34,37.51,37.51,0,0,1,2-12.95,36,36,0,0,1,2.11-4.94c.33-.69.7-1.27,1-1.79a13.25,13.25,0,0,1,.84-1.31,5.93,5.93,0,0,1,.79-1.06c.09.05-1,1.6-2.31,4.33a39.14,39.14,0,0,0-2,4.92,39.26,39.26,0,0,0-2,12.79,41.14,41.14,0,0,0,.41,5.29C241.11,335.6,241.67,337.4,241.57,337.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,226.91c0,.08-1.58-.61-4.18-1.45a47.47,47.47,0,0,0-21-1.86c-2.7.37-4.35.79-4.37.7a4.48,4.48,0,0,1,1.13-.37,29,29,0,0,1,3.18-.69,42.52,42.52,0,0,1,21.18,1.87,32.43,32.43,0,0,1,3,1.23A4.89,4.89,0,0,1,195.48,226.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.48,269a27.21,27.21,0,0,1-3.71-.06c-2.29-.09-5.45-.21-8.94-.29s-6.65-.13-8.94-.15a27.8,27.8,0,0,1-3.71-.13,4.48,4.48,0,0,1,1-.12c.64,0,1.57-.09,2.72-.12,2.29-.07,5.45-.09,8.95,0s6.66.27,9,.46c1.14.09,2.06.17,2.7.25A4.42,4.42,0,0,1,274.48,269Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.22,265.21c0,.09-1.25.52-3.2,1.48a31.3,31.3,0,0,0-12.5,11.14c-1.18,1.83-1.75,3.05-1.83,3a2.87,2.87,0,0,1,.32-.9,20.38,20.38,0,0,1,1.2-2.31,27.77,27.77,0,0,1,5.46-6.61,28.27,28.27,0,0,1,7.19-4.67,21.27,21.27,0,0,1,2.43-.92A3.66,3.66,0,0,1,294.22,265.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,233.16a14.89,14.89,0,0,0-5.08.71,34.14,34.14,0,0,0-5.13,2.28,41.58,41.58,0,0,1-6.34,2.85,25.83,25.83,0,0,1-12.53.81,22.49,22.49,0,0,1-3.69-1,6.64,6.64,0,0,1-1.29-.56c0-.1,1.88.69,5,1.2a26.86,26.86,0,0,0,12.31-.95,45.23,45.23,0,0,0,6.29-2.78,31.64,31.64,0,0,1,5.23-2.2,11.78,11.78,0,0,1,3.8-.55,7.13,7.13,0,0,1,1,.1C284.36,233.11,284.49,233.14,284.48,233.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.49,300.18a5.22,5.22,0,0,1-1.16.55c-.38.16-.85.35-1.41.53s-1.19.42-1.9.6a39,39,0,0,1-5.1,1.06,41.39,41.39,0,0,1-6.36.33,42.78,42.78,0,0,1-6.33-.71,38.1,38.1,0,0,1-5-1.37c-.71-.22-1.32-.49-1.86-.71s-1-.43-1.38-.61a6,6,0,0,1-1.13-.62c0-.09,1.69.71,4.49,1.59a41.74,41.74,0,0,0,5,1.24,41.22,41.22,0,0,0,12.54.38,42,42,0,0,0,5.06-.94C277.77,300.78,279.46,300.09,279.49,300.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.47,329.78a2.05,2.05,0,0,1-.39-.32c-.23-.23-.61-.54-1-1a23.81,23.81,0,0,1-3.16-4.24,34.55,34.55,0,0,1-4.46-16.75,67.41,67.41,0,0,1,2.27-17.27c.54-2.16,1-3.9,1.37-5.09.17-.55.31-1,.42-1.37s.16-.48.18-.47a1.67,1.67,0,0,1-.08.49c-.08.38-.19.84-.32,1.4-.3,1.29-.71,3-1.21,5.13A72.31,72.31,0,0,0,294,307.45,35.41,35.41,0,0,0,298.21,324a26.64,26.64,0,0,0,3,4.29C302,329.25,302.5,329.74,302.47,329.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.86,295.82a19.73,19.73,0,0,0-5.29-3,42.58,42.58,0,0,0-6.4-1.67,71,71,0,0,1-8-1.83,32.84,32.84,0,0,1-12.67-7.62,30.2,30.2,0,0,1-3-3.37c-.33-.42-.55-.77-.71-1s-.23-.36-.21-.37a12.63,12.63,0,0,1,1.08,1.24,34.75,34.75,0,0,0,3.09,3.23,33.93,33.93,0,0,0,12.57,7.39,76.83,76.83,0,0,0,7.91,1.86,41,41,0,0,1,6.44,1.79,15.31,15.31,0,0,1,3.94,2.2,7.91,7.91,0,0,1,.92.81C338.78,295.7,338.88,295.81,338.86,295.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.3,262.45a7.47,7.47,0,0,1-1.07-.93c-.33-.31-.73-.69-1.23-1.11s-1-.92-1.68-1.4a45.88,45.88,0,0,0-4.64-3.29,46.57,46.57,0,0,0-12.76-5.46,48.05,48.05,0,0,0-5.59-1.09c-.8-.13-1.53-.18-2.17-.24s-1.2-.11-1.65-.13a8.09,8.09,0,0,1-1.41-.13,6.81,6.81,0,0,1,1.41-.07,16.67,16.67,0,0,1,1.67,0c.64,0,1.39.05,2.2.16a43.35,43.35,0,0,1,5.65,1,48.54,48.54,0,0,1,6.68,2.24,47.47,47.47,0,0,1,6.22,3.28,43,43,0,0,1,4.63,3.41c.64.51,1.16,1,1.64,1.48a16,16,0,0,1,1.17,1.18A6.72,6.72,0,0,1,350.3,262.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,216.55a7.46,7.46,0,0,1-1.9.91,34.42,34.42,0,0,1-4.85,1.5,34.85,34.85,0,0,1-5,.8,7,7,0,0,1-2.1,0c0-.16,3.17-.42,7-1.33S262.74,216.4,262.8,216.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,357.39a2.78,2.78,0,0,1-3.06,3.53h0a2.77,2.77,0,0,1-2.28-2l-.85-3.14.13,0a2.91,2.91,0,0,1-3.25,3.43h0c-1.31,0-2.44-1.91-2.82-2.92h0a5.44,5.44,0,0,1-5.08-2.44l-5.87-9.16-10.87-7.95,6.58-23.49,23.39,15.14c.92.72,1.06,1,2.52,2.37l15.1,13.89c-1.71,1-3.16.95-5.54,0s-12.8-8-12.8-8l4.7,20.65",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.26,338.07s.27.12.69.41l.78.54a4.72,4.72,0,0,1,1,.84,4.35,4.35,0,0,1,.8,1.35c.18.53.37,1.07.57,1.64l1.28,3.76c.89,2.68,1.67,5.1,2.21,6.87a16.9,16.9,0,0,1,.77,2.89,17.1,17.1,0,0,1-1.12-2.78c-.63-1.74-1.47-4.14-2.36-6.81-.43-1.33-.85-2.6-1.24-3.77-.18-.58-.35-1.13-.52-1.65a4.25,4.25,0,0,0-.67-1.27,5.19,5.19,0,0,0-.86-.84l-.72-.61C278.44,338.3,278.24,338.1,278.26,338.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,356.32a4.48,4.48,0,0,1-.33-1l-.75-2.68c-.64-2.26-1.49-5.39-2.58-8.8s-2.23-6.45-3.6-8.33a7.23,7.23,0,0,0-1.91-1.91c-.55-.34-.9-.44-.89-.5a.67.67,0,0,1,.27.05,3.57,3.57,0,0,1,.72.27,6.57,6.57,0,0,1,2.11,1.87c1.49,1.9,2.69,5,3.79,8.39s1.9,6.58,2.44,8.87c.27,1.14.47,2.07.6,2.72A3.52,3.52,0,0,1,292.33,356.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37,357.74a4.46,4.46,0,0,1-.41-1.05c-.25-.8-.56-1.77-.93-2.92-.76-2.47-1.77-5.89-2.86-9.67s-2-7.1-2.75-9.7a4.66,4.66,0,0,0-1.6-2.44,6.08,6.08,0,0,0-1-.52.64.64,0,0,1,.3,0,2.46,2.46,0,0,1,.79.33,4.7,4.7,0,0,1,1.83,2.49c.82,2.47,1.79,5.89,2.9,9.67s2.05,7.23,2.72,9.72c.3,1.16.56,2.15.76,3A5.35,5.35,0,0,1,298.37,357.74Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-118"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.47,140.89a3.5,3.5,0,1,0,3.5-3.5A3.5,3.5,0,0,0,440.47,140.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429.96,
    cy: 140.89,
    r: 3.5,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.49,139.14a3.5,3.5,0,1,0,4.78-1.28A3.49,3.49,0,0,0,412.49,139.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.74,100a4.67,4.67,0,0,0-.7,0l-2.08.06c-.46,0-1,0-1.54.07l-1.83.26-2.14.31-2.4.59a38.67,38.67,0,0,0-11.59,5,41,41,0,0,0-18.8,30.76,43.57,43.57,0,0,0-.11,5.61c.07.94.05,1.91.19,2.86s.29,1.92.43,2.89a41.14,41.14,0,0,0,3.9,11.41,43.89,43.89,0,0,0,7.45,10.26,43,43,0,0,0,10.74,7.71,39,39,0,0,0,13.09,4,26.93,26.93,0,0,0,3.49.29,31.9,31.9,0,0,0,3.53.07,42.34,42.34,0,0,0,7.06-.89,41.39,41.39,0,0,0,14.07-5.93l-.42.05,14.33,5.75.85.34-.24-.88-4.22-15.32-.07.37a41.07,41.07,0,0,0,7.65-17.5,37.44,37.44,0,0,0,.56-9,30.41,30.41,0,0,0-.41-4.31q-.16-1.06-.33-2.1c-.12-.69-.33-1.36-.5-2a41,41,0,0,0-16-23.31,39.27,39.27,0,0,0-9.51-5l-2.15-.77-2-.52-1.86-.46c-.6-.11-1.18-.17-1.72-.26-1.08-.13-2-.32-2.87-.36l-2.1-.07-1.29,0a3,3,0,0,0-.44,0,1.29,1.29,0,0,0,.44.06l1.28.11,2.09.14c.83.06,1.77.27,2.85.43A40.78,40.78,0,0,1,469,131c.15.66.36,1.32.48,2s.2,1.36.31,2.06a29.3,29.3,0,0,1,.38,4.23,37,37,0,0,1-.58,8.79A40.51,40.51,0,0,1,462,165.18l-.13.17.06.21q2,7.42,4.18,15.33l.61-.54-14.33-5.77-.22-.09-.21.13a40.21,40.21,0,0,1-20.66,6.66,33,33,0,0,1-3.45-.06,25.71,25.71,0,0,1-3.41-.29,38.21,38.21,0,0,1-12.8-3.91,42.49,42.49,0,0,1-10.52-7.53,43.12,43.12,0,0,1-7.32-10A40.6,40.6,0,0,1,390,148.3c-.15-1-.3-1.89-.44-2.83s-.12-1.88-.19-2.81a41.92,41.92,0,0,1,.08-5.5,40.49,40.49,0,0,1,18.31-30.39,39,39,0,0,1,11.41-5.14l2.36-.63,2.12-.35,1.82-.3c.56-.06,1.07-.08,1.52-.11l2.07-.15A3.27,3.27,0,0,0,429.74,100Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.f41e0f1df29d299e6ea3fc2cbb7b9a75.svg";
export { ForwardRef as ReactComponent };